import RecordsGrid from "./RecordsGrid";

/**
 * Renders the "RecordsPage" page
 * @returns {JSX.Element}
 * @constructor
 */
const RecordsPage = () => {
    return (
        <div>
            <RecordsGrid />
        </div>
    );
}

export default RecordsPage;
